import React, { Suspense } from 'react';
import DynamicCompRenderer from './DynamicCompRenderer';
import AnyErrorBoundary from '../global/AnyErrorBoundary';
import { emptyArray } from '../../shared/misc';

const EmptyLoading = () => null;

const ComponentsArrRenderer = ({ components = emptyArray, parent = emptyArray, ...restProps }) => (
  <>
    <AnyErrorBoundary>
      <Suspense fallback={<EmptyLoading />}>
        {components?.map((comp, idx) => (
          // comp.id || idx - in admin panel we pass single jsx component to ComponentArrRenderer
          // as eg. components=[JMEText]. This components Array has `comp.id` undefined.
          <DynamicCompRenderer
            key={comp?.id || idx}
            parent={[...parent, 'components', idx]}
            {...restProps}
            {...comp}
          />
        ))}
      </Suspense>
    </AnyErrorBoundary>
  </>
);

ComponentsArrRenderer.processPropVmTypes = (props) => {
  const { components, ...restProps } = props;
  return DynamicCompRenderer.processPropVmTypes(restProps);
};

export default ComponentsArrRenderer;
